import clsx from 'clsx';
import { FC, SVGAttributes } from 'react';
import { overrideTailwindClasses } from 'tailwind-override';

export type IconType = React.ComponentType | string;

export type IconSizeType =
  | 'fw'
  | 'xxs'
  | 'xs'
  | 'sm'
  | '1x'
  | 'lg'
  | 'xl'
  | '2x'
  | '2.5x'
  | '3x'
  | '4x'
  | '5x'
  | '6x'
  | '7x'
  | '8x'
  | '9x'
  | '10x'
  | 'default';

interface IconProps extends SVGAttributes<SVGElement> {
  icon: IconType;
  fill?: string;
  size?: IconSizeType;
  width?: number;
  height?: number;
}

const sizeMap = {
  fw: 'fw',
  xxs: '10',
  xs: '12',
  sm: '14',
  '1x': '16',
  lg: '18',
  xl: '20',
  '2x': '22',
  '2.5x': '32',
  '3x': '48',
  '4x': '64',
  '5x': '80',
  '6x': '96',
  '7x': '112',
  '8x': '128',
  '9x': '144',
  '10x': '160',
  default: '24',
};

const Icon: FC<IconProps> = ({
  className,
  fill,
  icon: IconWrapper,
  size = 'xl',
  ...rest
}) => {
  if (typeof IconWrapper === 'string') {
    const classes = overrideTailwindClasses(
      clsx(
        'flex justify-center items-center fill-current',
        fill,
        IconWrapper,
        className,
        `ri-${size}`
      )
    );
    return <i data-testid="icon-selector" className={classes} />;
  }
  return (
    <i
      className={clsx(
        'flex items-center justify-center fill-current',
        fill,
        className
      )}
    >
      <IconWrapper
        data-testid="icon-selector"
        height={sizeMap[size]}
        {...rest}
      />
    </i>
  );
};

export default Icon;
